import type { EdgeId } from '@ipfabric/utils';
import { PATH_INSPECTOR_DETAIL_TAB } from 'components/DeviceView/deviceViewConstants';
import { isNodeEntity } from 'components/DeviceView/deviceViewTypes';
import { selectEntityTab } from 'components/DeviceView/model/commands/selectEntityTab';
import { isPathLookupGraphMetadata } from 'components/Graph/GraphState';
import { canSelectDeviceViewPathLookupTable } from 'components/Graph/helpers/canSelectDeviceViewPathLookupTable';
import { canSelectHighlightedPathLookupEdge } from 'components/Graph/helpers/canSelectHighlightedPathLookupEdge';
import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';
import { option } from 'fp-ts';
import { pipe } from 'fp-ts/lib/pipeable';
import { selectPathInspectorForwardedPacket } from './selectPathInspectorForwardedPacket';

interface SelectPathInspectorHighlightedEdgeCommand {
  edgeId: EdgeId;
}

export const selectPathInspectorHighlightedEdge: GraphCommandFactory<
  SelectPathInspectorHighlightedEdgeCommand
> = (cmdContext, dispatch) => (command) => {
  const { graph, graphMetadata, pathlookup } = cmdContext.getState();
  const { edgeId } = command;
  if (
    isPathLookupGraphMetadata(graphMetadata) &&
    canSelectHighlightedPathLookupEdge(edgeId, pathlookup)
  ) {
    pipe(
      graph.edges[edgeId],
      option.fromNullable,
      option.map((edgeData) => {
        const { activeNodeSn } = pathlookup.pathInspector;
        if (activeNodeSn !== null) {
          dispatch(selectPathInspectorForwardedPacket, {
            edgeId: edgeData.id,
            nodeSn: activeNodeSn,
            packetSource: 'edge',
          });
        }

        const foundDeviceViewEntity = cmdContext
          .getDeviceView()
          .deviceViewEntities.find(
            (entity) =>
              isNodeEntity(entity) &&
              entity.sn === pathlookup.pathInspector.activeNodeSn,
          );
        if (canSelectDeviceViewPathLookupTable(foundDeviceViewEntity)) {
          cmdContext.getDeviceView().dispatch(selectEntityTab, {
            deviceViewEntityId: foundDeviceViewEntity!.id,
            tabId: PATH_INSPECTOR_DETAIL_TAB,
          });
        }
      }),
    );
  }
};
